/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */

// eslint-disable-next-line no-array-constructor
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}"
  let date
  if (typeof time === "object") {
    date = time
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        time = time.replace(new RegExp(/-/gm), "/")
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value]
    }
    return value.toString().padStart(2, "0")
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return "刚刚"
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前"
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前"
  } else if (diff < 3600 * 24 * 2) {
    return "1天前"
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + "月" + d.getDate() + "日" + d.getHours() + "时" + d.getMinutes() + "分"
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ")
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split("&")
  searchArr.forEach(v => {
    const index = v.indexOf("=")
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

/**
 * 水印
 * @param settings
 */
export function watermark(settings) {
  // 默认设置
  const defaultSettings = {
    watermark_txt: "text",
    watermark_x: 20, // 水印起始位置x轴坐标
    watermark_y: 20, // 水印起始位置Y轴坐标
    watermark_rows: 20, // 水印行数
    watermark_cols: 20, // 水印列数
    watermark_x_space: 100, // 水印x轴间隔
    watermark_y_space: 50, // 水印y轴间隔
    watermark_color: "rgba(170, 170, 170, .6)", // 水印字体颜色
    watermark_alpha: 0.3, // 水印透明度
    watermark_fontsize: "13px", // 水印字体大小
    watermark_font: "微软雅黑", // 水印字体
    watermark_width: 210, // 水印宽度
    watermark_height: 80, // 水印长度
    watermark_angle: 15 // 水印倾斜度数
  }
  Object.assign(defaultSettings, settings)
  const oTemp = document.createDocumentFragment()
  // 获取页面最大宽度
  const p_width = Math.max(document.body.scrollWidth, document.body.clientWidth)
  const cutWidth = p_width * 0.015
  const page_width = p_width - cutWidth
  // 获取页面最大高度
  //   let page_height = Math.max(document.body.scrollHeight,document.body.clientHeight)+450;
  // let page_height = document.body.scrollHeight+document.body.scrollTop;
  const page_height = window.innerHeight - 100
  // 如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
  if (
    defaultSettings.watermark_cols === 0 ||
    parseInt(
      defaultSettings.watermark_x +
        defaultSettings.watermark_width * defaultSettings.watermark_cols +
        defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)
    ) > page_width
  ) {
    defaultSettings.watermark_cols = parseInt(
      (page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) /
        (defaultSettings.watermark_width + defaultSettings.watermark_x_space)
    )
    defaultSettings.watermark_x_space = parseInt(
      (page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) /
        (defaultSettings.watermark_cols - 1)
    )
  }
  // 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
  if (
    defaultSettings.watermark_rows === 0 ||
    parseInt(
      defaultSettings.watermark_y +
        defaultSettings.watermark_height * defaultSettings.watermark_rows +
        defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)
    ) > page_height
  ) {
    defaultSettings.watermark_rows = parseInt(
      (defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) /
        (defaultSettings.watermark_height + defaultSettings.watermark_y_space)
    )
    defaultSettings.watermark_y_space = parseInt(
      (page_height - defaultSettings.watermark_y - defaultSettings.watermark_height * defaultSettings.watermark_rows) /
        (defaultSettings.watermark_rows - 1)
    )
  }
  let x
  let y
  for (let i = 0; i < defaultSettings.watermark_rows; i++) {
    y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i
    for (let j = 0; j < defaultSettings.watermark_cols; j++) {
      x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j
      const mask_div = document.createElement("div")
      mask_div.id = "mask_div" + i + j
      mask_div.className = "mask_div"
      mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt))
      // 设置水印div倾斜显示
      mask_div.style.webkitTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
      mask_div.style.MozTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
      mask_div.style.msTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
      mask_div.style.OTransform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
      mask_div.style.transform = "rotate(-" + defaultSettings.watermark_angle + "deg)"
      mask_div.style.visibility = ""
      mask_div.style.position = "absolute"
      mask_div.style.left = x + "px"
      mask_div.style.top = y + "px"
      mask_div.style.overflow = "hidden"
      mask_div.style.zIndex = "9999"
      mask_div.style.pointerEvents = "none" // pointer-events:none 让水印不遮挡页面的点击事件
      mask_div.style.opacity = defaultSettings.watermark_alpha
      mask_div.style.fontSize = defaultSettings.watermark_fontsize
      mask_div.style.fontFamily = defaultSettings.watermark_font
      mask_div.style.color = defaultSettings.watermark_color
      mask_div.style.textAlign = "center"
      mask_div.style.width = defaultSettings.watermark_width + "px"
      mask_div.style.height = defaultSettings.watermark_height + "px"
      mask_div.style.display = "block"
      oTemp.appendChild(mask_div)
    }
  }
  document.body.appendChild(oTemp)
}

/**
 * 获取文件后缀
 * @param {string} fileName 文件名
 * @returns {string} 文件后缀
 */
export function getFileSuffix(fileName) {
  if (!fileName) return ""
  const index = fileName.lastIndexOf(".")
  const suffix = fileName.substr(index + 1)
  return suffix
}

// 格式化时间
export function getYMDHMS(timestamp) {
  if (!timestamp) {
    return ""
  }
  const time = new Date(timestamp)
  const year = time.getFullYear()
  const month = (time.getMonth() + 1).toString().padStart(2, "0")
  const date = time.getDate().toString().padStart(2, "0")
  const hours = time.getHours().toString().padStart(2, "0")
  const minute = time.getMinutes().toString().padStart(2, "0")
  const second = time.getSeconds().toString().padStart(2, "0")

  return year + "-" + month + "-" + date + " " + hours + ":" + minute + ":" + second
}

/**
 * 树形结构转为一维数组
 * @param tree
 * @returns {[]}
 */
export function treeToArray(tree, keyName = "children") {
  // tree是要传递的树形结构数组
  const arr = []
  const expanded = datas => {
    if (datas && datas.length > 0) {
      datas.forEach(e => {
        arr.push(e)
        expanded(e[keyName])
      })
    }
  }
  expanded(tree)
  return arr
}

/**
 * 一维数组转树形
 * @param data
 * @param parentId
 * @returns {[]}
 */
export function translateDataToTree(data, parentId = 0) {
  const tree = []
  let temp
  data.forEach((item, index) => {
    if (data[index].parentId == parentId) {
      const obj = data[index]
      temp = translateDataToTree(data, data[index].menuId)
      if (temp.length > 0) {
        obj.children = temp
        obj.list = temp
      }
      tree.push(obj)
    }
  })
  return tree
}

// 格式化朋友圈时间
export function diffTime(time) {
  const startTime = new Date(time) // 包含时间的日期字符串
  const nowTime = new Date()
  const Day = 24 * 60 * 60 * 1000
  const Hours = 60 * 60 * 1000
  const Minutes = 60 * 1000
  const diffDay = parseInt((nowTime - startTime) / Day)
  const diffHours = parseInt((nowTime - startTime) / Hours)
  const diffMinutes = Math.floor((nowTime - startTime) / Minutes)

  if (diffDay != 0 && diffDay < 7) {
    return diffDay + "天前"
  } else if (diffDay == 0 && diffHours != 0) {
    return diffHours + "小时前"
  } else if (diffDay == 0 && diffHours == 0 && diffMinutes != 0) {
    return diffMinutes + "分钟前"
  } else if (diffDay == 0 && diffHours == 0 && diffMinutes == 0) {
    return "刚刚"
  } else {
    return time
  }
}

// 根据访问地址,进行api接口判断
export function checkApiUrl() {
  const host = "tfeimall.com"
  if (process.env.VUE_APP_ENV === "test") {
    // 测试环境
    return "https://pre-api." + host + "/"
  } else if (process.env.VUE_APP_ENV === "production") {
    // 正式环境
    return "https://api." + host + "/"
  } else {
    return "/"
  }
}
/**
 * arraybuffer转json
 * @param {object} content arraybuffer 数据
 */
export function arrbuffer2json(content) {
  return new Promise(resolve => {
    const resBlob = new Blob([content])
    const reader = new FileReader()
    reader.readAsText(resBlob, "utf-8")
    reader.onload = () => {
      resolve(JSON.parse(reader.result))
    }
  })
}

export function processExportBlobFile(blobData, type, fileName) {
  const blob = new Blob([blobData], { type }) // 将服务端返回的文件流excel文件
  if (window.navigator.msSaveOrOpenBlob) {
    // IE10
    navigator.msSaveBlob(blob, fileName)
  } else {
    const link = document.createElement("a")
    link.style.display = "none"
    link.href = URL.createObjectURL(blob) // 创建一个指向该参数对象的URL
    link.download = fileName
    link.click() // 触发下载
    URL.revokeObjectURL(link.href) // 释放通过 URL.createObjectURL() 创建的 URL
  }
}

/**
 * 输入框限制输入 只允许输入数字
 * value 数值 必填
 * max 最大值 选填
 * min 最小值 选填
 * length 小数点保留位数 选填
 * isBlur 失去焦点触发
 */
export function limitInputNumber(value, max = null, min = null, length = null, isBlur = false, isMoney = false) {
  if (!value && value !== 0) {
    return min >= 0 ? min : null
  }
  // 是否需要保留小数
  value = value.toString()
  if (!length) {
    if (max < 0 || min < 0) {
      value = value.replace(/[^\-\d]+/g, "")
    } else {
      value = value.replace(/[^0-9]/gi, "")
    }
  } else {
    // 保留数字和小数点
    if (max < 0 || min < 0) {
      value = value.replace(/[^\-\d^\.]+/g, "")
    } else {
      value = value.replace(/[^\d^\.]+/g, "")
    }
    if (value.indexOf(".") > 0) {
      value = value.slice(0, value.indexOf(".") + (length + 1))
    } else if (value.indexOf(".") === 0 && value.length === 1) {
      value = 0 + value
    } else if (value.indexOf(".") === value.length - 1 && value.length != 0 && isBlur) {
      value = value.substring(0, value.length - 1)
    }
  }
  if (max) {
    max = Number(max)
    const tempValue = Number(value)
    if (tempValue > max) {
      value = max
    }
  }
  if (min) {
    min = Number(min)
    const tempValue = Number(value)
    if (tempValue < min) {
      value = min
    }
  }
  if (isMoney) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === ".") {
        break
      }
      if (value[i] == 0 && value[i + 1] !== "." && i == 0) {
        value = value.slice(i + 1, value.length - 1)
        i--
      }
    }
  }
  if (isBlur) {
    return Number(value)
  } else {
    return value
  }
}

/**
 * 根据静态路由给每个children添加全路径
 */
export function getFullPath(nowMenu, parentMenu = null) {
  if (parentMenu) {
    nowMenu.forEach(item => {
      item.fullPath = parentMenu.fullPath + "/" + item.path
      if (item.children && item.children.length > 0) {
        getFullPath(item.children, item)
      }
    })
  } else {
    nowMenu.forEach(item => {
      item.fullPath = item.path
      if (item.children && item.children.length > 0) {
        getFullPath(item.children, item)
      }
    })
  }
  return nowMenu
}

// 是否移动端
export const isMobile = () => {
  return !!navigator.userAgent.match(/(iPhone|iPad|Macintosh|Android|ios|iOS|WebOS|Windows Phone|Phone)/i)
}

// 是否安卓端
export const isAndroid = () => {
  return /android/i.test(navigator.userAgent.toLowerCase())
}

// 是否ios端
export const isIOS = () => {
  const reg = /iPhone|iPad|iOS|Macintosh/i
  return reg.test(navigator.userAgent.toLowerCase())
}

// 判断消息类型正则
export const msgMatchRegex =
  /^(.*(@chatroom|^gh_\w+$|@openin).*|weibo|weixin|fmessage|filehelper|floatbottle|feedsapp|medianote|masssendapp|mphelper|newsapp|notification_messages|qmessage|qqmail|qqsync|qqsafe|voiceinputapp|voicevoipapp|voipapp|blogapp|brandsessionholder|brandsessionholder_weapp|exmail_tool|tmessage)$/i

// 千分号
export function numberToCurrencyNo(value) {
  if (!value) return 0
  // 获取整数部分
  console.log("格式化值：" + value)
  const intPart = Math.trunc(value)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,")
  // 预定义小数部分
  let floatPart = ""
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split(".")
  if (valueArray.length === 2) {
    // 有小数部分
    console.log("有小数")
    floatPart = valueArray[1].toString().match(/^\d+(?:\.\d{0,2})?/) // 取得小数部分
    const newFloatPart = floatPart.length <= 2 ? floatPart.toString().padEnd(2, "0") : floatPart.toString().substring(0, 2)
    return "￥" + intPartFormat + "." + newFloatPart
  }
  return "￥" + value + ".00"
}

// 获取滚动的dom
export function getScrollContainer(el, vertical) {
  let parent = el
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window
    }
    if (isScroll(parent, vertical)) {
      return parent
    }
    parent = parent.parentNode
  }
  return parent
}
export function isScroll(el, vertical) {
  const determinedDirection = vertical !== null || vertical !== undefined
  const overflow = determinedDirection
    ? vertical
      ? getComputedStyle(el)["overflow-y"]
      : getComputedStyle(el)["overflow-x"]
    : getComputedStyle(el)["overflow"]
  return overflow.match(/(scroll|auto)/)
}

/**
 * 根据XPath查询元素
 * @param {string} xpath - 要查询的XPath表达式
 * @returns {Element|null} - 查询到的元素或null
 */
export const findElementByXPath = xpath => {
  try {
    return document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
  } catch (e) {
    console.error("XPath查询错误:", e)
    return null
  }
}

import Vue from "vue"
// 实例自定义事件
export const _bus = new Vue()
